const _import = name => {
    return resolve => require([`../../views/${name}`], resolve)
  }

  const customerservice = {
    path: '/Service',
    component: _import('Service'),
    children: [{
        meta: { navShow: true, titleHide: false, diffBg: true, title: '客服中心'},
        path: '',
        name: 'ServiceBase',
        component: _import('Service/Base'),
      },
      {
        path: 'Problems',
        redirect: '/Service/problems/list',
        meta: { navShow: false, titleHide: true,title: '常见问题'},
        component: _import('Service/Problems'),
        children:[
            {
              path: 'list',
              meta: { navShow: false ,titleHide:true },
              name: 'List',
              component: _import('Service/Problems/problems'),
            },
            {
              path: 'details',
              meta: { navShow: false ,titleHide:true },
              name: 'Details',
              component: _import('Service/Problems/details'),
            },
        ]
      },
    ]
  }

  export default customerservice



// WEBPACK FOOTER //
// ./src/pages/build821/router/module/CustomerService.js